import styled from 'styled-components';

export const WppBtnIcon = styled.img`
  width: 10vw;
  height: 10vw;
  position: fixed;
  right: 4.5vw;
  bottom: 3.5vw;
`;
